import R from 'ramda';
import actionTypes from '../actionTypes';

const initialState = {
  roles: [],
  ownershipTypes: [],
  contractBlocks: [],
  workTypes: [],
  subWorkTypes: [],
  subWorkTypesCoreg: [],
};

export default (state = initialState, action) => {
  let index, contractBlocks;

  switch (action.type) {
    case actionTypes.WORK_TYPES_GET_SUCCESS:
      return {
        ...state,
        workTypes: action.data,
      };

    case actionTypes.SUBWORK_TYPES_GET_SUCCESS:
      return {
        ...state,
        subWorkTypes: action.data.filter(
          (subWorkType) => subWorkType.is_active
        ),
        subWorkTypesCoreg: action.data,
      };

    case actionTypes.ROLES_GET_SUCCESS:
      return {
        ...state,
        roles: action.roles,
      };

    case actionTypes.OWNERSHIP_TYPES_GET_SUCCESS:
      return {
        ...state,
        ownershipTypes: action.data,
      };

    case actionTypes.CONTRACT_BLOCKS_GET_SUCCESS:
      return {
        ...state,
        contractBlocks: action.data,
      };

    case actionTypes.CONTRACT_BLOCKS_UPDATE_CONTENT:
      const { id, content, options } = action.payload;

      contractBlocks = state.contractBlocks;
      index = R.findIndex(R.propEq('id', id))(contractBlocks);

      if (index !== -1) {
        contractBlocks[index].content = content.content;
        contractBlocks[index].options = options;
        contractBlocks[index].checked = content.checked;
      }

      return {
        ...state,
        contractBlocks: contractBlocks.concat(),
      };

    case actionTypes.CONTRACT_BLOCKS_RESET_CONTENTS:
      contractBlocks = state.contractBlocks.map((block) => ({
        ...block,
        content: '',
        options: null,
        checked: false,
      }));

      return {
        ...state,
        contractBlocks: contractBlocks.concat(),
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// src/redux/reducers/global.js